// Lightweight global trigger for the quote wizard via a window event.
// Avoids any React context module-instance pitfalls.
const EVENT = "softpro:open-quote";

export const openQuote = (preset = null) => {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: preset }));
};

export const QUOTE_EVENT = EVENT;

export const useQuote = () => ({ openQuote });
